/**
 * Числа по-русски — одним местом на кабинет.
 *
 * До 14.10.26 `new Intl.NumberFormat("ru-RU")` стоял в 46 файлах под десятком
 * имён (`nf`, `mf`, `pf`, `RUB`, `шт`, `юани`…), и одно имя значило разное:
 * `mf` в витрине — целые рубли, в ячейках размеров — с копейками; `pf` — то
 * ровно один знак, то «до одного». Здесь имя = набор знаков, и только так:
 * одноимённые форматтеры с разным округлением в соседних файлах читались бы
 * как расхождение там, где его нет (аудит фронта 12.10.26, §5.1 и §5.4).
 *
 * Разделитель тысяч `ru-RU` — неразрывный пробел U+00A0, разделитель дробной
 * части — запятая. Проверка — `web/checks/format.check.ts`.
 */

/** Как есть: целые без дробной части, дроби — до трёх знаков (умолчание Intl). */
export const nf = new Intl.NumberFormat("ru-RU");

/** Без дробной части — деньги в ленте, юани папки, штрафы: копейка там шум. */
export const nf0 = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 });

/** До одного знака: «10,9», но «10», а не «10,0». */
export const nf1 = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 1 });

/** До двух знаков: оплаты, где копейки бывают, но нули не печатаются. */
export const nf2 = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2 });

/** Ровно один знак — доли: «30,0 %» рядом с «29,3 %», а не «30 %». */
export const fixed1 = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

/** Ровно два знака — деньги с копейками там, где сверяют: финотчёт, баланс. */
export const fixed2 = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Процент по-русски с одним знаком: «10,9 %», а не «10.9 %». */
export function pct(value: number): string {
  return `${fixed1.format(value)} %`;
}

/** Число или ПРОЧЕРК. Ноль — это ноль, `null` — «сказать нечего». */
export function num(value: number | null | undefined): string {
  return value === null || value === undefined ? "—" : nf.format(value);
}

/** Число с единицей или прочерк: `money(1234, "₽")` → «1 234 ₽». */
export function money(value: number | null | undefined, unit: string): string {
  return value === null || value === undefined ? "—" : `${nf.format(value)} ${unit}`;
}
